import { render, staticRenderFns } from "./reportesPreciosTratamientos.vue?vue&type=template&id=67f1d106"
import script from "./reportesPreciosTratamientos.vue?vue&type=script&lang=js"
export * from "./reportesPreciosTratamientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports